module.exports = __webpack_public_path__ + "static/102_001-14c7c1809e4a1845fb5ccb44e27647b0.jpg";